export default "__VITE_ASSET__BUwSbZ5U__"